import {TranslationRuleJson} from "./TranslationRulesPage";

export const TRANSLATION_RULES: TranslationRuleJson[] = []; // TOTALLY DEPRECATED